class SaveDesignActionType {
    static saveDesignWithImages = {
        start: 'SAVE_DESIGN_START',
        success: 'SAVE_DESIGN_SUCCESS',
        fail: 'SAVE_DESIGN_FAIL',
        reset: 'SAVE_DESIGN_RESET',
    };

    static saveOnlyImages = {
        start: 'SAVE_IMAGES_START',
        success: 'SAVE_IMAGES_SUCCESS',
        fail: 'SAVE_IMAGES_FAIL',
        reset: 'SAVE_IMAGES_RESET',
    };

    static saveDesignName_NAME = 'SAVE_DESIGN_NAME_';
    static saveDesignName = {
        start: SaveDesignActionType.saveDesignName_NAME + 'START',
        success: SaveDesignActionType.saveDesignName_NAME + 'SUCCESS',
        fail: SaveDesignActionType.saveDesignName_NAME + 'FAIL',
        reset: SaveDesignActionType.saveDesignName_NAME + 'RESET',
    };
}

export default SaveDesignActionType;
